export const parseCoords = (lat, lng) => {
  const latitude = parseFloat(lat);
  const longitude = parseFloat(lng);

  return {
    LatitudeSign: isNaN(latitude) ? null : latitude < 0 ? '-' : '+',
    LatitudeDegree: isNaN(latitude) ? null : Math.abs(latitude),
    LongitudeSign: isNaN(longitude) ? null : longitude < 0 ? '-' : '+',
    LongitudeDegree: isNaN(longitude) ? null : Math.abs(longitude),
  };
};

export const getCoords = (row) => ({
  Latitude:
    row?.LatitudeDegree != null ? row.LatitudeDegree * (row.LatitudeSign === '-' ? -1 : 1) : '',
  Longitude:
    row?.LongitudeDegree != null ? row.LongitudeDegree * (row.LongitudeSign === '-' ? -1 : 1) : '',
});
